<template>
  <div class="taobao_container">
    <md-field>
      <md-input-item
        ref="input0"
        v-model="taobaoAccount"
        placeholder="請輸入淘寶賬號"
      >
        <div class="viewbtn" slot="right" @click="bindTaoBaoAccount">
          <span>綁定</span>
        </div>
      </md-input-item>
    </md-field>
  </div>
</template>

<script>
import { InputItem, Field, Toast } from "mand-mobile";

export default {
  name: "coup",
  components: {
    [InputItem.name]: InputItem,
    [Field.name]: Field
  },
  data() {
    return {
      userinfo: {},
      taobaoAccount: ''
    };
  },
  activated() {
    this.userinfo = JSON.parse(localStorage.getItem("userinfoMobie"));
    this.taobaoAccount = this.userinfo.taobaoAccount ? this.userinfo.taobaoAccount : ''
  },
  methods: {
    bindTaoBaoAccount() {

        const par = {
          taobaoAccount: this.taobaoAccount
        };
        Toast.loading("绑定中")
        this.http
          .APIASK(this.ports.userupdate, "post", par)
          .then(res => {
            Toast.succeed("绑定成功");
            this.getUserInfo();
          })
          .catch(err => {});
    },
    getUserInfo() {
      this.http
        .APIASK(this.ports.getUserInfo, "get")
        .then(res => {
          localStorage.setItem("userinfoMobie", JSON.stringify(res));
          this.userinfo = JSON.parse(localStorage.getItem("userinfoMobie"));
          this.$router.go(-1)
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="less">
.md-tab-bar-item.is-active {
  color: #e32c1a;
}
.md-tab-bar-ink {
  background-color: #e32c1a;
}
.md-tab-bar {
  position: absolute;
  top: 1rem;
  width: 100%;
  padding: 0;
}


.taobao_container {
  .md-field {
    padding: 0 0.4rem;
  }

  .viewbtn {
    padding: 0.2rem 0.4rem;
    background-color: rgba(236, 112, 74, 1);
    color: rgba(255, 255, 255, 1);
    border-radius: 0.1rem;
    font-size: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .coupitem {
    margin-top: 0.2rem;
    display: flex;
    border-radius: 0.1rem;
    align-items: center;
    background-color: white;
    position: relative;
    .banner {
      position: absolute;
      font-size: 0.2rem;
      bottom: 0.1rem;
      left: 0.5rem;
    }
    .couypleft {
      padding: 0.2rem 0;
      display: flex;
      padding-left: 0.5rem;
      flex-direction: column;
      font-size: 0.3rem;
      align-items: flex-start;
      margin-top: -0.5rem;
      .price {
        font-size: 0.45rem;
        color: #f97004;
        margin-bottom: 0.2rem;
      }

      .rule {
        color: #cccccc;
      }
    }
    .couypright {
      padding: 0.2rem 0;
      display: flex;
      padding-left: 0.5rem;
      flex-direction: column;
      font-size: 0.28rem;
      align-items: flex-start;
      margin-top: 0.2rem;
      .name {
        font-size: 0.4rem;
        margin-bottom: 0.2rem;
        font-weight: bolder;
      }
      .rule {
        color: #cccccc;
      }
      .krkkrt {
        padding: 0.08rem 0.12rem;
        background-color: #2a78dc;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        margin-top: 0.2rem;
        border-radius: 0.08rem;
      }
    }
  }
}
</style>
